export const MIN_RADIUS = 50
export const MAX_RADIUS = 900
